<ng-container [ngSwitch]="officeField.WebInputType | filedControlType">
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.text">
    <app-input
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [alignment]="alignment"
      [config]="config"></app-input>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.number">
    <app-input
      type="number"
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-input>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.percent">
    <app-input
      type="percent"
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-input>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.checkbox">
    <app-checkbox
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-checkbox>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.notes">
    <app-input
      type="textarea"
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-input>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.combobox">
    <app-select
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-select>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.richtext">
    <app-rich-text
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-rich-text>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.date">
    <app-datepicker
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-datepicker>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.month">
    <app-datepicker
      type="month"
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-datepicker>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.time">
    <app-input
      type="time"
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-input>
  </ng-container>
  <ng-container *ngSwitchCase="formFieldControlTypeEnum.file">
    <app-image-upload
      [officeField]="officeField"
      [controlName]="officeField.Seq"
      [formGroupInstance]="formGroupInstance"
      [config]="config"
      [alignment]="alignment"></app-image-upload>
  </ng-container>
</ng-container>
